
      var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 86,
  height: 84,
  viewBox: "0 0 86 84"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-success_18e3745676b417cc__a",
  x1: "93.19%",
  x2: "-6.12%",
  y1: "73.657%",
  y2: "20.05%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "var(--theme-primary, #810ea9)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M44.038.187C65.208.707 82.751 16.76 85.14 37.8c2.39 21.041-11.107 40.62-31.621 45.873a2.8 2.8 0 1 1-1.389-5.425c17.805-4.56 29.52-21.553 27.446-39.816C77.502 20.171 62.276 6.236 43.9 5.785c-18.374-.45-34.266 12.72-37.233 30.86-2.967 18.138 7.9 35.686 25.46 41.113a2.8 2.8 0 0 1-1.654 5.351c-20.23-6.253-32.75-26.47-29.332-47.369C4.56 14.842 22.87-.333 44.038.187zm19.175 31.746a2.8 2.8 0 0 1 .127 3.82l-.131.14-20.907 20.862a2.8 2.8 0 0 1-3.818.129l-.14-.131-10.651-10.651a2.8 2.8 0 0 1 3.82-4.091l.14.13 8.673 8.674 18.927-18.887a2.8 2.8 0 0 1 3.96.005z",
  fill: "url(#icons-success_18e3745676b417cc__a)",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"86\" height=\"84\" viewBox=\"0 0 86 84\">\r\n    <defs>\r\n        <linearGradient id=\"09ydca3ova\" x1=\"93.19%\" x2=\"-6.12%\" y1=\"73.657%\" y2=\"20.05%\">\r\n            <stop offset=\"0%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"100%\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"url(#09ydca3ova)\" transform=\"translate(-145 -254)\">\r\n            <g>\r\n                <path d=\"M44.038.187C65.208.707 82.751 16.76 85.14 37.8c2.39 21.041-11.107 40.62-31.621 45.873-1.498.384-3.024-.52-3.407-2.018-.384-1.498.52-3.023 2.018-3.407 17.805-4.56 29.52-21.553 27.446-39.816C77.502 20.171 62.276 6.236 43.9 5.785c-18.374-.45-34.266 12.72-37.233 30.86-2.967 18.138 7.9 35.686 25.46 41.113 1.477.457 2.305 2.025 1.848 3.502-.456 1.478-2.024 2.305-3.502 1.849C10.243 76.856-2.277 56.639 1.141 35.74 4.56 14.842 22.87-.333 44.038.187zm19.175 31.746c1.047 1.049 1.089 2.72.127 3.82l-.131.14-20.907 20.862c-1.048 1.046-2.719 1.089-3.818.129l-.14-.131-10.651-10.651c-1.094-1.094-1.094-2.867 0-3.96 1.048-1.048 2.72-1.092 3.82-.131l.14.13 8.673 8.674 18.927-18.887c1.095-1.092 2.868-1.09 3.96.005z\" transform=\"translate(138 246) translate(7 8)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-success.18e3745676b417ccace66eaa158231d1.svg"),
        {
          React: SvgIconsSuccess,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      